<script>
    import { generatePieceCard } from "../http";
    import Icon from "./Icon.svelte";
</script>

<button type="button" class="button" on:click={generatePieceCard}>
    <Icon name="download"/> <span>Pobierz kartę utworów</span>
</button>
